$(document).ready(function(){
  $('.index-all-images').slick({
    dots: true,
    arrows: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed:1500,
    infinite:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
});